
/** components */
// import ListFilter from "@/views/product/VacationListFilter.vue";
import ListProductSkeleton from "@/views/product/ListProductSkeleton.vue";
// import ListHotProduct from "@/views/product/ListHotProduct.vue";
import NoResult from "@/views/product/components/ListNoResult.vue";
// import SortBar from "@/views/product/ListProductSortBar.vue";
import ProductItem from "@/components/product/list-product-item-vacation.vue";
// import ResourceSearchHead from "@/views/product/components/ResourceSearchHead.vue";
// import ResourceBannerSwiper from "@/views/product/ResourceBannerSwiper.vue";
import VBreadcrumb from "@/components/VBreadcrumb.vue";
import VPagination from "~/components/VPagination/index.vue";
import PlatformAdvertStair from "~/components/product/PlatformAdvertStair.vue";
import PlatformAdvertStairSwiper from "~/components/product/PlatformAdvertStairSwiper.vue";

import ProductFilterItem from "~/components/automation/product-filter-item.vue";
import FilterSortBar from "@/components/product/filterSortBar.vue";
import AppDock from "~/components/layouts/AppDock.vue";
// helpers
import { get, dayjs } from "@/utils/helpers";

import {
  ref,
  computed,
  defineComponent,
  // reactive,
  useStore,
  // watchEffect,
  useFetch,
  useRoute,
  useRouter,
  watch,
  // nextTick,
} from "@nuxtjs/composition-api";

// import usePagination from "@/composables/usePagination";
// import useProductFavorite from '~/views/product/composables/useProductFavorite';
// import useProductJoinShop from '~/views/product/composables/useProductJoinShop'
import {
  useProductVacationFilter,
  useVacationProductList,
  useProductCruiseDate,
} from "~/composables/vacation";
import usePlatformAdvertStairStore from "~/composables/usePlatformAdvertStairStore";

import { toValue } from "@vueuse/core";

// import consola from 'consola'

function transformRange(value: string) {
  const [min = "", max = ""] = value.split("-");
  return { min, max };
}

// function createSearchData() {
//   return {
//     name: "",
//     holidays: [],
//     months: [],
//     days_range: [],
//     city: [],
//     price_range: [],
//     product_type: [],
//     sort_type: "",
//     sort_name: "",
//     date_start: "",
//     date_end: "",
//   };
// }

export default defineComponent({
  name: "VacationList",
  head: {
    title: "度假产品",
  },
  auth: false,
  layout: "Main",
  components: {
    AppDock,
    // SearchHeader,
    VBreadcrumb,
    ListProductSkeleton,
    // ListHotProduct,
    NoResult,
    // SortBar,
    FilterSortBar,
    // ResourceSearchHead,
    // ResourceBannerSwiper,
    ProductItem,
    PlatformAdvertStair,
    PlatformAdvertStairSwiper,
    VPagination,

    ProductFilterItem,

    // ShareShopProduct
  },

  setup() {
    const breadcrumbs = [
      { label: "首页", to: "/" },
      { label: "度假旅游", to: "/product/vacation" },
      { label: "度假产品列表" },
    ];

    const route = useRoute();
    // const searchData = reactive(createSearchData());
    // const searchKeywords = computed(() => {
    //   let { keywords = "" } = route.value.query;
    //   return keywords;
    // });

    const getSearchParam = () => {
      const {
        sort_name = '1',
        sort_type = '',
        day_range = "",
        tag,
        month,
        destination,
        date_start,
        date_end,
        keyword,
        product_type
      } = searchData;

      return {
        sort_name,
        sort_type,
        day: transformRange(day_range),
        tag,
        month,
        destination,
        date_start,
        date_end,
        keyword,
        product_type
      };
    };

    const {
      state: productData,
      isLoading: productLoading,
      onPageChange,
      execute: fetchProductList,
      pageIndex,
    } = useVacationProductList(() => {
      return {
        page_index: toValue(pageIndex),
        page_size: 10,
        ...getSearchParam(),
      };
    });

    const {
      isLoading: isLoadingFilterData,
      state: filterData,
      execute: fetchFilterData,
      cities,
      travelDates,
      days,
      tags,
      dateRange,
      onDateRangeChange,
      searchData,
      labels,
      types
    } = useProductVacationFilter(() => getSearchParam());

    useFetch(async () => {
      await Promise.all([
        fetchFilterData(0),
        fetchProductList(0),
        fetchDates(0),
      ]);
    });

    const router = useRouter();

    const store = useStore();

    // ======================= 推荐位 =======================
    const adStore = usePlatformAdvertStairStore("vacation_search_right");

    const { state: dates, execute: fetchDates } = useProductCruiseDate();

    return {
      breadcrumbs,
      isLoadingFilterData,
      filterData,

      cities,
      travelDates,
      dateRange,
      days,
      tags,
      types,

      onDateRangeChange,

      searchData,
      labels,

      productData,
      // pagination,
      productLoading,

      dates,
      // onSearch,

      onPageChange,
      // onFilterChange,

      loggedIn: computed(() => {
        return store.getters.loggedIn;
      }),
      adStore,
    };
  },
  data() {
    return {
      datePickerOptions: {
        cellClassName: (date: Date) => {
          // @ts-ignore
          return this.dates.includes(dayjs(date).format("YYYY-MM-DD"))
            // @ts-ignore
            ? this.$style.highlight
            : "";
        },
      },
    };
  },
});
